import store from '@/store';
// import router from '@/router';
import i18n from '@/i18n';
import api from '../../../api/collectors';
import * as types from './types';

export default {

  getCollectors(context) {
    return api.getCollectors()
      .then((response) => {
        context.commit(types.GET_COLLECTORS_SUCCESS, response.data.data.collectors);
        return response;
      })
      .catch(() => {
        store.dispatch('application/openSnackbar', {
          message: i18n.t('collectors.error.message.get.collectors'),
        });
        context.commit(types.GET_COLLECTORS_FAILURE);
      });
  },

  getCollectorById(context, id) {
    return api.getCollectorById(id)
      .then(data => data.data.data)
      .catch((error) => {
        console.log(error);
      });
  },

  getSubscribedCollectors() {
    return api.getSubscribedCollectors()
      .then(data => data.data.data.csList)
      .catch((error) => {
        console.log(error);
      });
  },

  subscribeToACollector(context, collector) {
    return api.subscribeToACollector(collector)
      .then(data => data)
      .catch((error) => {
        console.log(error);
        return Promise.reject(error);
      });
  },

  deleteSubscription(context, id) {
    return api.deleteSubscription(id)
      .then(data => data)
      .catch(() => {
        store.dispatch('application/openSnackbar', {
          message: i18n.t('collectors.error.message.delete.collectors'),
        });
        return Promise.reject();
      });
  },

  updateSubscription(context, params) {
    api.updateSubscription(params)
      .then(data => data)
      .catch((error) => {
        console.log(error);
        return Promise.reject(error);
      });
  },

  startCollectorRecuperation(context, id) {
    api.startCollectorRecuperation(id)
      .then(data => data)
      .catch((error) => {
        console.log(error);
      });
  },

  getCollectorsByCategory(context, category) {
    api.getCollectorsByCategory(category)
      .then(data => data)
      .catch((error) => {
        console.log(error);
      });
  },

  breadcrumbSlice(context, params) {
    context.commit(types.BREADCRUMB_SLICE, params);
  },

  updateCurrentGroup(context, object) {
    context.commit(types.BREADCRUMB_UPDATE_CURRENT_GROUP, object);
  },

  breadcrumbPush(context, object) {
    context.commit(types.BREADCRUMB_PUSH, object);
  },

  setBreadcrumbs(context, array) {
    context.commit(types.SET_BREADCRUMBS, array);
  },

  updateAsideElmts(context, array) {
    context.commit(types.UPDATE_ASIDE_ELMTS, array);
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/collectors/actions.js